import {
  CTAButtons,
  CTAButtonsAlt,
} from "../../../../../global/components/Buttons/buttons";
import React, { useState, useEffect } from "react";
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import Table from "../../../../Components/Table/Table";
import Pagination from "../../../../Components/Pagination/Pagination";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  TableActions,
  TableActionsNew,
} from "../../../../Components/Misc/Actions";
import "./style.css";
import { useTablesState } from "../States/States";
import {
  approvePaymentType,
  declinePaymentType,
  getPaymentType,
  createPaymentType,
  updatePaymentType,
  getFeeSetup,
  getAccountLedgerSetup,
  createPaymentRecognitionSetup,
  getPaymentRecognitionSetup,
  approvePaymentRecognitionSetup,
  declinePaymentRecognitionSetup,
  deletePaymentRecognitionSetup,
  updatePaymentRecognitionSetup,
} from "../../../../../../utils/redux/Finance/PaymentSetup/PaymentSetupSlice";
import { FiX, FiArrowLeft } from "react-icons/fi";
import DeclineModal from "../Components/DeclineModal";
import { URL } from "../../../../../../utils/routes";
import RouteLayout from "../../../../Components/Layout/RouteLayout";
import { Button } from "@mui/material";
import { GetVendorType } from "../../../../../../utils/redux/Global/GlobalSlice";
import { toast } from "react-toastify";
import {
  FilterButton,
  ProDropFilter,
} from "../../../../Components/Search/Search";

// Table Headers format:
let mockHeaders = [
  {
    title: "Payment Type",
    key: "paymentTypeId",
  },
  {
    title: "Credit Ledger",
    key: "creditLedgerId",
  },
  {
    title: "Debit Ledger",
    key: "debitLedgerId",
  },
  {
    title: "installement Type",
    key: "installementType",
  },
  {
    title: "Approval Status",
    key: "approvalStatus",
  },
  {
    title: "Actions",
    key: null,
  },
];

function convertDate(isoDate) {
  let timestamp = Date.parse(isoDate);
  let jsDate = new Date(timestamp);
  let fDate = new Intl.DateTimeFormat("en-us", {
    dateStyle: "short",
    timeStyle: "short",
  });
  return fDate.format(jsDate);
}

export default function PaymentRecognitionSetup() {
  // Filter states
  const [filters, setFilters] = useState([]);
  const [search, setSearch] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [comment, setComment] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [currentType, setCurrentType] = useState(null); // Changed to null to distinguish between new and existing
  const [declineStatus, setDeclineStatus] = useState(false);

  const [selectedItems, setSelectedItems] = useState([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const paymentTypes = useSelector(
    (state) => state?.paymentSetup?.paymentTypes
  );

  const accountLedgerSetup = useSelector(
    (state) => state?.paymentSetup?.accountLedgerSetup?.result
  );

  const paymentRecognitionSetup = useSelector(
    (state) => state?.paymentSetup?.paymentRecognitionSetup?.result
  );

  const filterBy = [
    {
      name: "Pending",
      filter: 1,
    },
    {
      name: "Approved",
      filter: 0,
    },
    {
      name: "Declined",
      filter: 7,
    },
  ];

  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [approvalStatus, setFilter] = useState("all");
  const [installementTypeEnum, setInstallementTypeEnum] = useState("all");

  // Initialize state with the provided object values
  const initialState = {
    paymentTypeId: "",
    creditLedgerId: "",
    debitLedgerId: "",
    installementType: "",
  };

  const [formData, setFormData] = useState(initialState);

  // Handle change for input fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const closeModal = () => {
    setOpenModal(false);
    setDeclineStatus(false);
    setFormData(initialState); // Reset form data when closing the modal
    setCurrentType(null); // Clear current type
  };

  const installementType = [
    { name: "OneTimePayment", filter: 0 },
    { name: "StaggardPayment", filter: 1 },
  ];

  let mockRowOptions = [
    {
      name: "Edit",
      action: (item) => {
        setCurrentType(item);
        setFormData({
          paymentTypeId: item.paymentTypeId || "",
          creditLedgerId: item.creditLedgerId || "",
          debitLedgerId: item.debitLedgerId || "",
          installementType: item.installementType || "",
        });
        setOpenModal(true);
      },
    },
    {
      name: "Approve",
      action: (item) => {
        const payload = {
          id: item?.id,
          status: 0,
        };
        dispatch(approvePaymentRecognitionSetup(payload)).then((response) => {
          if (response?.payload?.successful === true) {
            setRefresh(!refresh);
            toast.success(response?.payload?.statusMessage);
          } else {
            toast.error(response?.payload?.statusMessage);
          }
        });
      },
    },
    {
      name: "Decline",
      action: (item) => {
        const payload = {
          id: item?.id,
          status: 7,
        };
        dispatch(declinePaymentRecognitionSetup(payload)).then((response) => {
          if (response?.payload?.successful === true) {
            setRefresh(!refresh);
            toast.success(response?.payload?.statusMessage);
          } else {
            toast.error(response?.payload?.statusMessage);
          }
        });
      },
    },
  ];

  const getPaymentTypeName = (id) => {
    const paymentType = paymentTypes?.result?.find((type) => type.id === id);
    return paymentType?.name;
  };

  const getCreditLedgerName = (id) => {
    const creditLedger = accountLedgerSetup?.find((type) => type.id === id);
    return creditLedger?.accountName;
  };

  const getDebitLedgerName = (id) => {
    const debitLedger = accountLedgerSetup?.find((type) => type.id === id);
    return debitLedger?.accountName;
  };

  const getInstallementType = (id) => {
    const installement = installementType?.find((type) => type.filter === id);
    return installement?.name;
  };

  const getFilterBy = (id) => {
    const filter = filterBy?.find((type) => type.filter === id);
    return filter?.name;
  };

  useEffect(() => {
    dispatch(getPaymentType({ pageSize: 10000, pageNumber: 1 }));
    dispatch(
      getPaymentRecognitionSetup({
        pageSize: 10000,
        pageNumber: 1,
        Status: approvalStatus === "all" ? "" : approvalStatus,
        installementType:
          installementTypeEnum === "all" ? "" : installementTypeEnum,
      })
    );
    dispatch(getAccountLedgerSetup({ pageSize: 10000, pageNumber: 1, ApprovalStatus: 0 }));
  }, [pageNumber, pageSize, refresh]);

  const handleCreateOrUpdatePaymentRecognitionSetup = async () => {
    if (!formData.paymentTypeId) {
      return toast.error("Payment Type is required");
    }

    if (!formData.creditLedgerId) {
      return toast.error("Credit Ledger is required");
    }

    if (!formData.debitLedgerId) {
      return toast.error("Debit Ledger is required");
    }

    if (!formData.installementType) {
      return toast.error("Installment Type is required");
    }

    if (+formData.creditLedgerId === +formData.debitLedgerId) {
      return toast.error("Credit Ledger and Debit Ledger cannot be the same");
    }

    const payload = {
      paymentTypeId: +formData.paymentTypeId,
      creditLedgerId: +formData.creditLedgerId,
      debitLedgerId: +formData.debitLedgerId,
      installementType: +formData.installementType,
    };

    try {
      setLoading(true);
      let response;
      if (currentType) {
        // Editing existing
        response = await dispatch(
          updatePaymentRecognitionSetup({
            id: currentType.id,
            ...payload,
          })
        );
      } else {
        // Creating new
        response = await dispatch(createPaymentRecognitionSetup(payload));
      }

      if (response?.payload?.successful === true) {
        setRefresh(!refresh);
        toast.success(response?.payload?.statusMessage);
        setOpenModal(false);
        setLoading(false);
      } else {
        toast.error(response?.payload?.statusMessage);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      toast.error("An error occurred. Please try again.");
    }
  };

  return (
    <RouteLayout>
      <button
        className="text-customGreen flex items-center gap-2 text-xl"
        onClick={() => navigate(-1)}
      >
        <FiArrowLeft />
        Back
      </button>

      <div className="w-full mt-5">
        {openModal && (
          <DeclineModal hideModal={setOpenModal}>
            <div
              className="bg-white w-full overflow-hidden"
              style={{
                borderTopLeftRadius: "5px",
                borderTopRightRadius: "5px",
              }}
            >
              <header className="w-full py-3 bg-customGreen px-4 flex items-center justify-between">
                <p className="text-white text-baseFont">
                  {declineStatus
                    ? "Reason for Delete"
                    : currentType
                    ? "Edit Payment Recognition Setup"
                    : "Add Payment Recognition Setup"}
                </p>
                <button
                  className="text-baseFont text-white"
                  onClick={closeModal}
                >
                  <FiX />
                </button>
              </header>
            </div>
            <section className="bg-white p-6">
              <div className="flex mt-6 mb-12 justify-between">
                <div className="flex gap-4 w-full">
                  <div className="flex flex-col gap-4 w-full">
                    {/* PAYMENT TYPE */}
                    <div className="flex flex-col">
                      <div className="text-primary/50 text-sm mb-1">
                        Payment Type
                        <span className="text-red-500">*</span>
                      </div>
                      <select
                        className="block w-full px-4 py-2 text-gray-700 border border-slate-300 bg-slate-50 text-sm rounded-md focus:outline-none focus:ring-0"
                        name="paymentTypeId"
                        value={formData.paymentTypeId || ""}
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          Choose Payment Type
                        </option>
                        {paymentTypes?.result?.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* CREDIT LEDGER */}
                    <div className="flex flex-col">
                      <div className="text-primary/50 text-sm mb-1">
                        Credit Ledger
                        <span className="text-red-500">*</span>
                      </div>
                      <select
                        className="block w-full px-4 py-2 text-gray-700 border border-slate-300 bg-slate-50 text-sm rounded-md focus:outline-none focus:ring-0"
                        name="creditLedgerId"
                        value={formData.creditLedgerId || ""}
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          Choose Credit Ledger
                        </option>
                        {accountLedgerSetup?.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.accountName}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* DEBIT LEDGER */}
                    <div className="flex flex-col">
                      <div className="text-primary/50 text-sm mb-1">
                        Debit Ledger
                        <span className="text-red-500">*</span>
                      </div>
                      <select
                        className="block w-full px-4 py-2 text-gray-700 border border-slate-300 bg-slate-50 text-sm rounded-md focus:outline-none focus:ring-0"
                        name="debitLedgerId"
                        value={formData.debitLedgerId || ""}
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          Choose Debit Ledger
                        </option>
                        {accountLedgerSetup?.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.accountName}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* INSTALLMENT TYPE */}
                    <div className="flex flex-col">
                      <div className="text-primary/50 text-sm mb-1">
                        Installment Type
                        <span className="text-red-500">*</span>
                      </div>
                      <select
                        className="block w-full px-4 py-2 text-gray-700 border border-slate-300 bg-slate-50 text-sm rounded-md focus:outline-none focus:ring-0"
                        name="installementType"
                        value={formData.installementType || ""}
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          Choose Installment Type
                        </option>
                        {installementType?.map((option) => (
                          <option key={option.filter} value={option.filter}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full flex items-center justify-end gap-5 pt-3">
                <button
                  className="rounded-md py-1 px-4 text-baseFont text-customGreen"
                  style={{ border: "1px solid #305f32" }}
                  onClick={closeModal}
                >
                  Cancel
                </button>
                <button
                  disabled={loading}
                  className={`rounded-md py-1 px-4 text-baseFont ${
                    loading
                      ? "bg-gray-400 text-gray-700 border-gray-500 cursor-not-allowed"
                      : "bg-customGreen text-white border-customGreen"
                  }`}
                  style={{ border: "1px solid #305f32" }}
                  onClick={handleCreateOrUpdatePaymentRecognitionSetup}
                >
                  {loading ? "Loading..." : currentType ? "Update" : "Proceed"}
                </button>
              </div>
            </section>
          </DeclineModal>
        )}

        <div
          className={`${DashboardStyle.dashboard_table_holder} rounded p-10 bg-white `}
        >
          <div className="w-full flex items-center justify-between mb-1">
            <h1 className="text-customGreen text-xl font-semibold">
              Payment Recognition Setup
            </h1>
            <CTAButtons onClick={() => setOpenModal(true)}>
              Add Payment Recognition Setup
            </CTAButtons>
          </div>
          <div className={DashboardStyle.dashboard_filter}>
            <ProDropFilter
              filter={approvalStatus}
              setFilter={setFilter}
              name={"Approval Status"}
              filterBy={filterBy}
              value={approvalStatus}
            />

            <ProDropFilter
              filter={installementTypeEnum}
              setFilter={setInstallementTypeEnum}
              name={"Installment Type"}
              filterBy={installementType}
            />
            <FilterButton onClick={() => setRefresh(!refresh)} name="" />
          </div>
          <Table>
            <thead>
              <tr>
                <th>
                  <p>ID</p>
                </th>
                {mockHeaders.map((header) => (
                  <th key={header.key}>{header.title}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              <RequestTable
                isLoading={false}
                data={paymentRecognitionSetup}
                keys={mockHeaders.map((header) => header.key)}
                selectable={true}
                rowOptions={mockRowOptions}
                selectedItems={selectedItems}
                getPaymentTypeName={getPaymentTypeName}
                getCreditLedgerName={getCreditLedgerName}
                getDebitLedgerName={getDebitLedgerName}
                getInstallementType={getInstallementType}
                getFilterBy={getFilterBy}
              />
            </tbody>
          </Table>
        </div>

        {/* <Pagination
          last_page={paymentTypes?.totalPages}
          present_page={paymentTypes?.currentPage}
          totalRows={paymentTypes?.totalRows}
          pageSize={pageSize}
          setPageSize={(page) => setPageSize(page)}
          click={(page) => setPageNumber(page)}
        /> */}
      </div>
    </RouteLayout>
  );
}

function RequestTable({
  data,
  rowOptions,
  getPaymentTypeName,
  getCreditLedgerName,
  getDebitLedgerName,
  getInstallementType,
  getFilterBy,
}) {
  return (
    <>
      {data?.map((item, index) => (
        <tr key={item.id}>
          <td>
            <p>{index + 1}</p>
          </td>
          <td>{getPaymentTypeName(item?.paymentTypeId)}</td>
          <td>{getCreditLedgerName(item?.creditLedgerId)}</td>
          <td>{getDebitLedgerName(item?.debitLedgerId)}</td>
          <td>{getInstallementType(item?.installementType)}</td>
          <td>{getFilterBy(item?.approvalStatus)}</td>
          <td>
            <TableActionsNew
              // url={`/dashboard/finance/${URL.WitholdingTaxSetup}/${item.id}`}
              actions={rowOptions.map((option) => ({
                name: option.name,
                action: () => option.action(item),
              }))}
            />
          </td>
        </tr>
      ))}
    </>
  );
}
